import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch } from "react-redux";
import { ADDED_BY_ID } from "../../../Constants";
import { postMaterialTypeDatas } from "../../../redux/action";

const statusOptions = [
    { value: 93, label: "Active" },
    { value: 94, label: "Inactive" }
]

const AddMaterialType = (props) => {

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;

    const materialTypeDatas = props.materialTypeDatas;
    const materialTypeID = props.materialTypeID;
    const singleMaterialTypeData = props.singleMaterialTypeData;

    let dispatch = useDispatch();

    const [materialType, setMaterialType] = useState({
        MaterialTypeCode: "",
        Name: "",
        Description: "",
        StatusID: null,
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
    })

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (materialTypeID && singleMaterialTypeData?.length > 0) {
            const materialTypeDatas = singleMaterialTypeData[0];
            setMaterialType({
                MaterialTypeID: materialTypeID,
                MaterialTypeCode: materialTypeDatas.MaterialTypeCode || "",
                Name: materialTypeDatas.Name || "",
                Description: materialTypeDatas.MaterialTypeDescription || "",
                CompanyID: materialTypeDatas.CompanyID,
                AddedByID: ADDED_BY_ID,
                StatusID: materialTypeDatas.StatusID || null
            });
        }
    }, [materialTypeID, singleMaterialTypeData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setMaterialType((previousData) => ({
            ...previousData,
            [name]: value,
        }));
        setErrors((previousErrors) => ({
            ...previousErrors,
            [name]: "",
        }));
    };

    const handleSelectChange = (selectedOption) => {
        setMaterialType((previousData) => ({
            ...previousData,
            StatusID: selectedOption ? selectedOption.value : null,
        }));
        setErrors((previousErrors) => ({
            ...previousErrors,
            StatusID: ""
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!materialType.MaterialTypeCode) newErrors.MaterialTypeCode = "required!";
        if (!materialType.Name) newErrors.Name = "required!";
        if (!materialType.Description) newErrors.Description = "required!";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddMaterialType = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(materialType),
            };
            dispatch(postMaterialTypeDatas(requestOption, props.handleCloseModal, materialTypeID, materialTypeDatas));
            console.log(materialType, 'materialType');
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{materialTypeID ? "Edit Material Type" : "Add Material Type"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={6}>
                                    <div>
                                        <label>Material Type Code <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="MaterialTypeCode"
                                            value={materialType.MaterialTypeCode}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.MaterialTypeCode && <div className="text-danger">{errors.MaterialTypeCode}</div>}
                                </Col>
                                <Col md={6}>
                                    <div>
                                        <label>Material Type Name<span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="Name"
                                            value={materialType.Name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.Name && <div className="text-danger">{errors.Name}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div>
                                        <label className="pb-1 pt-1"> Description <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            as='textarea'
                                            rows='2'
                                            name="Description"
                                            value={materialType.Description}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.Description && <div className="text-danger">{errors.Description}</div>}
                                </Col>
                            </Row>
                            <Row>
                                {materialTypeID && <Col md={6}>
                                    <div>
                                        <label>Status <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statusOptions}
                                            value={statusOptions.find(option => option.value === materialType.StatusID) || null}
                                            onChange={(selected) => handleSelectChange(selected, "StatusID")}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddMaterialType} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddMaterialType;
